import { ReactComponent as StarDiscoverySvg } from 'assets/images/star-discovery.svg';
import PropTypes from 'prop-types';

const STAR_COUNT = 5;
const STAR_COLOR_FILLED = '#FF7A00';
const STAR_COLOR_EMPTY = '#F2F2F2';

function IconStarDiscovery({
  star = 5,
  hiddenSubStar = false,
  size = 20,
}) {
  const normalizedStar = Math.min(
    STAR_COUNT,
    Math.max(0, Number(star) || 0),
  );

  const renderStar = (index) => {
    const fillRatio = Math.min(1, Math.max(0, normalizedStar - index));

    if (fillRatio === 0) {
      if (hiddenSubStar) {
        return null;
      }

      return (
        <StarDiscoverySvg
          key={index}
          width={size}
          height={size}
          style={{ color: STAR_COLOR_EMPTY }}
        />
      );
    }

    if (fillRatio >= 1) {
      return (
        <StarDiscoverySvg
          key={index}
          width={size}
          height={size}
          style={{ color: STAR_COLOR_FILLED }}
        />
      );
    }

    return (
      <span
        key={index}
        style={{
          position: 'relative',
          display: 'inline-flex',
          width: size,
          height: size,
          flexShrink: 0,
        }}
      >
        {!hiddenSubStar && (
          <StarDiscoverySvg
            width={size}
            height={size}
            style={{ color: STAR_COLOR_EMPTY }}
          />
        )}
        <span
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: `${fillRatio * 100}%`,
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <StarDiscoverySvg
            width={size}
            height={size}
            style={{ color: STAR_COLOR_FILLED, display: 'block' }}
          />
        </span>
      </span>
    );
  };

  return (
    <div className="d-flex" style={{ gap: '3px' }}>
      {Array.from({ length: STAR_COUNT }, (_, index) => renderStar(index))}
    </div>
  );
}

IconStarDiscovery.propTypes = {
  star: PropTypes.number,
  hiddenSubStar: PropTypes.bool,
  size: PropTypes.number,
};

IconStarDiscovery.defaultProps = {
  star: 5,
  hiddenSubStar: false,
  size: 20,
};

export default IconStarDiscovery;
